import axios from 'axios'

export async function addNotification ({ ...values }) {
  let data = {
    customer_email: values.email,
    id_product: values.productId,
    id_product_attribute: values.combinationId
  }

  const response = await axios.get(values.url, { // eslint-disable-line
    params: data
  })

  return response
}



// WEBPACK FOOTER //
// ./src/api/productNotifications/addNotification.js